{
  "menu.newRoute": "Ny rutt",
  "menu.routePlanManager": "Sparade rutter",
  "menu.savedPlaces": "Sparade platser",
  "menu.vesselConfigurator": "Fartygsinställningar",
  "menu.instructions": "Instruktioner",
  "menu.tour": "Guidad tur",
  "menu.information": "Information",
  "information.tabMapLicenses": "Datakällor",
  "information.tabOpenSource": "Öppen källkod",
  "information.dataSources.osmTitle": "OpenStreetMap",
  "information.dataSources.osmText": "© <0>OpenStreetMap contributors</0>, licens <1>ODbL 1.0</1>.",
  "information.dataSources.digitrafficTitle": "Digitraffic (Fintraffic)",
  "information.dataSources.digitrafficText": "Källa: <0>Fintraffic / digitraffic.fi</0>, licens <1>CC BY 4.0</1>.",
  "information.dataSources.fmiTitle": "Finlands meteorologiska institut",
  "information.dataSources.fmiText": "Källa: <0>FMI öppna data</0>, licens <1>CC BY 4.0</1>.",
  "information.dataSources.traficomTitle": "Traficom",
  "information.dataSources.traficomText": "Källa: <0>Traficom öppna data</0>, licens <1>CC BY 4.0</1>.",
  "information.dataSources.vaylaTitle": "Trafikledsverket",
  "information.dataSources.vaylaText": "Trafikledsverket / nedladdningstjänst, licens CC BY 4.0.",
  "information.dataSources.traficomNauticalTitle": "Transport- och kommunikationsverket",
  "information.dataSources.traficomNauticalText": "Inte för navigationsbruk. Uppfyller inte kraven för ett ändamålsenligt sjökort (sjökort baserat på öppna data).",
  "information.dataSources.traficomLicenseNotice": "©Traficom lisenssi nro TRAFICOM/108936/00.04.01.10/2026",
  "information.dataSources.traficomWarningText": "VAROITUS: Traficom ei ole tarkistanut tämän tuotteen tietoja, eikä\nse ota siten vastuuta tietojen oikeellisuudesta tai valmistuksen jäl-\nkeisistä muutoksista. Ei ole olemassa takuita siitä, että tämä tuote\nnoudattaa asianmukaisten navigointituotteiden käyttöä koskevia\nkansallisia tai kansainvälisiä säännöksiä.",
  "information.dataSources.mmlTopographicTitle": "Lantmäteriverket",
  "information.dataSources.mmlTopographicText": "Lantmäteriverkets terrängdatabas.",
  "information.dataSources.mmlNamesTitle": "Lantmäteriverket",
  "information.dataSources.mmlNamesText": "Lantmäteriverkets ortnamn 01/2023.",
  "information.dataSources.smhiTitle": "SMHI",
  "information.dataSources.smhiText": "Källa: SMHI.",
  "information.mapLicensesPlaceholder": "Licensinformation för kartdata läggs till senare.",
  "information.openSourceGeneratedFromLockfile": "Licenser för öppen källkod genereras från package-lock.json.",
  "information.searchPlaceholder": "Sök paket…",
  "information.licenseUnknown": "Okänd licens",
  "information.packageCount": "Paket: {{count}}",
  "menu.userAccount": "Användarkonto",
  "menu.harborManagement": "Hantering av hamninformation",
  "menu.showHarborUpdateDates": "Visa hamnarnas uppdateringsdatum",
  "menu.logout": "Logga ut",
  "menu.login": "Logga in",
  "menu.animate": "Animera",
  "demo.play": "Spela",
  "demo.pause": "Paus",
  "demo.speed": "Animationshastighet",
  "demo.close": "Stäng animation",
  "demo.beta": "Beta",
  "demo.boat.label": "Båt",
  "demo.boat.scrollHint": "Svep för fler",
  "demo.boat.sailboat": "Dagsseglare",
  "demo.boat.racingSailboat": "Kappsegling",
  "demo.boat.cruisingSailboat": "Kryssare",
  "demo.boat.smallMotorboat": "Öppen båt",
  "demo.boat.largeMotorboat": "Kabinkyacht",
  "demo.boat.speedboat": "Racerbåt",
  "demo.boat.rowingBoat": "Roddbåt",
  "demo.boat.kayak": "Kajak",
  "demo.boat.submarine": "Ubåt",
  "demo.boat.premiumDialog.title": "Sailmate Premium",
  "demo.boat.premiumDialog.message": "“{{boat}}” kräver Sailmate Premium. Prenumerera för att låsa upp alla fartyg i Animera och videoexport.",
  "demo.boat.premiumDialog.hint": "Premium inkluderar även sjökort, väder, AIS och avancerade navigationsverktyg.",
  "demo.boat.premiumDialog.subscribe": "Prenumerera",
  "demo.export.button": "Exportera video",
  "demo.export.title": "Exportera ruttvideo",
  "demo.export.description": "Renderar hela rutten på {{seconds}} s med Sailmate-logotypen. Redo för sociala medier.",
  "demo.export.duration": "Videolängd",
  "demo.export.durationOption": "{{seconds}} s",
  "demo.export.durationRecommended": "Bäst",
  "demo.export.durationHint": "För denna rutt på {{distance}} ser {{seconds}} s smidigast ut",
  "demo.export.durationCalmHint": "Vill du ha ett lugnare tempo? Prova {{seconds}} s",
  "demo.export.durationTooShort": "För kort för denna rutt — rörelsen skulle kännas stressad",
  "demo.export.durationRushedWarning": "Denna längd kan kännas stressad; en längre video är smidigare",
  "demo.export.aspect": "Bildförhållande",
  "demo.export.aspectHintLandscape": "16:9 — YouTube, X, liggande",
  "demo.export.aspectHintVertical": "9:16 — Reels, TikTok, Stories",
  "demo.export.scene": "Scen",
  "demo.export.scene.cinematic": "Filmisk",
  "demo.export.scene.follow": "Följ",
  "demo.export.scene.cinematicHint": "Kameran zoomer ut och cirklar mjukt. Båten stannar i bild och blir mindre när kameran drar ut",
  "demo.export.scene.followHint": "Kameran följer bakom båten längs rutten",
  "demo.export.titleText": "Titel",
  "demo.export.titleSource.none": "Ingen",
  "demo.export.titleSource.route": "Ruttnamn",
  "demo.export.titleSource.custom": "Egen text",
  "demo.export.titleSource.noneHint": "Ingen titel på videon",
  "demo.export.titleSource.routeHint": "“{{name}}” tonas bort efter några sekunder",
  "demo.export.titleSource.routeMissing": "Namnge rutten i ruttplanen för att visa den",
  "demo.export.titleCustomPlaceholder": "Titel på videon",
  "demo.export.titleMaxLength": "{{count}} / {{max}}",
  "demo.export.titleFont": "Typsnitt",
  "demo.export.titleFont.finlandica": "Finlandica",
  "demo.export.titleFont.outfit": "Outfit",
  "demo.export.titleFont.libreBaskerville": "Baskerville",
  "demo.export.titleBackground": "Bakgrund",
  "demo.export.titleBackground.glow": "Glow",
  "demo.export.titleBackground.dim": "Dim",
  "demo.export.titleBackground.highlight": "Fält",
  "demo.export.titleBackground.light": "Ljus",
  "demo.export.showElapsedDistance": "Visa tillryggalagd distans",
  "demo.export.showElapsedDistanceHint": "Visas längst ner i videon",
  "demo.export.distanceUnit": "Distansenhet",
  "demo.export.distanceUnitNm": "nm",
  "demo.export.distanceUnitKm": "km",
  "demo.export.cancel": "Avbryt",
  "demo.export.create": "Skapa video",
  "demo.export.rendering": "Skapar video… {{percent}} %",
  "demo.export.renderingHint": "Håll den här fliken öppen tills nedladdningen startar.",
  "demo.export.tipLabel": "Medan du väntar",
  "demo.export.tips.0": "Ett stigande vatten lyfter alla båtar — utom den som fortfarande står på trailern.",
  "demo.export.tips.1": "Rött till babord in i hamn — om du inte kommer från fel håll. Då litar man på sjökortet, inte på ramser.",
  "demo.export.tips.2": "Vinden tar alltid i fem minuter efter att du rullat in focken.",
  "demo.export.tips.3": "GPS är precis. Stenen du just hittade är ännu mer precis.",
  "demo.export.tips.4": "Om kaffet stannar i muggen, seglar du inte hårt nog.",
  "demo.export.tips.5": "Förtöjningslinor är aldrig för långa — förrän de är i propellern.",
  "demo.export.tips.6": "Prognosen är ett förslag. En kastby är en recension.",
  "demo.export.tips.7": "Det finns inget som heter för många fendrar — bara för få vittnen.",
  "demo.export.tips.8": "Kortaste vägen är en rak linje. Säkraste följer farleden.",
  "demo.export.tips.9": "Om allt går enligt plan — kolla vattenståndet en gång till.",
  "demo.export.tips.10": "En hand för båten, en för dig själv — och ändå tre till telefonen.",
  "demo.export.tips.11": "Ankaret tar bäst just efter att du förklarat för alla att det sitter.",
  "demo.export.tips.12": "God vind och medsjö… till lunchen, då båda vänder av ren elakhet.",
  "demo.export.tips.13": "Torrt i bilgen är ett tillfälligt tillstånd, inte en karaktärsfråga.",
  "demo.export.tips.14": "Ropa aldrig ”jag tar den!” på bryggan om du inte gillar teater.",
  "demo.export.tips.15": "Reva tidigt, reva ofta — och förklara ändå efteråt varför du inte rev tidigare.",
  "demo.export.tips.16": "Plottern är självsäker. Ekolodet är ärligt.",
  "demo.export.tips.17": "Det finns alltid tid att ta på flytväst — tills det plötsligt är för sent.",
  "demo.export.tips.18": "Vem som helst kan bära segel. Det är den som revar som seglar.",
  "demo.export.tips.19": "Bästa kajplatsen är den du kan lämna utan publik.",
  "demo.export.tips.20": "Springlinor finns så att stoltheten inte möter grannbåten.",
  "demo.export.tips.21": "Om du ser botten har du antingen tur — eller är på väg att förklara dig.",
  "demo.export.tips.22": "Väderappen uppdateras. Molnen väntar inte på uppdateringen.",
  "demo.export.tips.23": "Lämna båten snygg till nästa vakt — även om nästa vakt är du.",
  "demo.export.success": "Video nedladdad",
  "demo.export.error": "Kunde inte skapa videon",
  "demo.export.unsupported": "Videoexport stöds inte i den här webbläsaren",
  "menu.chartSettings": "Kartinställningar",
  "menu.chartSettingsSubtitle": "Enheter, S57-symboler och palett",
  "toolbar.routingMode": "Ruttredigeringsläge",
  "toolbar.routingModeOff": "Ruttredigering av",
  "toolbar.routingModeAuto": "Farledsruttning",
  "toolbar.routingModeManual": "Linjeruttning",
  "toolbar.reachArea": "Nåbart område",
  "toolbar.showReachArea": "Visa nåbart område",
  "toolbar.hideReachArea": "Dölj nåbart område",
  "toolbar.setReachArea": "Sätt nåbart område",
  "toolbar.addSailingPoint": "Lägg till seglingspunkt",
  "toolbar.search": "Sök",
  "mapControls.zoomIn": "Zooma in",
  "mapControls.zoomOut": "Zooma ut",
  "mapControls.resetNorth": "Återställ norr",
  "mapControls.forecast": "Väderprognos",
  "placeSearch.placeholder": "Sök platser…",
  "placeSearch.placesPlaceholder": "Sök platser…",
  "placeSearch.harborsPlaceholder": "Sök hamnar…",
  "placeSearch.inputLabel": "Sök platser",
  "placeSearch.tabPlaces": "Platser",
  "placeSearch.tabHarbors": "Hamnar",
  "placeSearch.emptyHint": "Börja skriva för att söka platser.",
  "placeSearch.loading": "Laddar platser…",
  "placeSearch.harborsLoading": "Laddar hamnar…",
  "placeSearch.unavailable": "Platssökning är inte tillgänglig",
  "placeSearch.harborsUnavailable": "Hamnsökning är inte tillgänglig",
  "placeSearch.retry": "Försök igen",
  "placeSearch.harborsEmptyHint": "Börja skriva för att söka hamnar.",
  "placeSearch.noResults": "Inga resultat",
  "placeSearch.clear": "Rensa",
  "placeSearch.close": "Stäng",
  "toolbar.layers": "Kartlager",
  "toolbar.menu": "Meny",
  "chartSettings.title": "Kartinställningar",
  "chartSettings.symbolSize": "Symbolstorlek",
  "chartSettings.symbolSizeSmall": "Liten",
  "chartSettings.symbolSizeMedium": "Mellan",
  "chartSettings.symbolSizeLarge": "Stor",
  "chartSettings.symbolStyle": "Symbolstil",
  "chartSettings.symbolStyleOfficial": "Officiell",
  "chartSettings.symbolStyleColourful": "Färgrik",
  "chartSettings.palette": "Palett",
  "chartSettings.paletteNormal": "Normal",
  "chartSettings.paletteNight": "Natt",
  "chartSettings.paletteHighContrast": "Hög kontrast",
  "chartSettings.units": "Enheter",
  "chartSettings.unitsNautical": "kn, nm",
  "chartSettings.unitsSi": "km/h, km",
  "chartSettings.s57Section": "S57-sjökort",
  "chartSettings.s57SectionDescription": "Dessa inställningar påverkar endast S57-sjökort.",
  "chartSettings.simplifiedS57": "Förenklat sjökort",
  "chartSettings.simplifiedS57Description": "Dölj lodningar, sektorfyrar, djupkurvor, restriktionsområden, kablar och rörledningar för snabbare rendering.",
  "inactivity.title": "Uppdatering pausad",
  "inactivity.body": "Den automatiska uppdateringen av AIS och väder är pausad på grund av inaktivitet. Fortsätt för att återuppta liveuppdateringar.",
  "inactivity.continue": "Fortsätt uppdatera",
  "layers.title": "Kartlager",
  "layers.sectionCharts": "Sjökort",
  "layers.sectionOverlays": "Tilläggslager",
  "layers.sectionSummaryNone": "Inga på",
  "layers.sectionSummaryMore": "+{{count}}",
  "layers.sectionPois": "Platser och POI",
  "layers.sectionRoutes": "Rutter",
  "layers.sectionRestrictions": "Begränsningsområden",
  "layers.sectionLiveData": "Aktuell data",
  "layers.weather": "Väderobservationer",
  "layers.harbor": "Hamnar",
  "layers.recreationSites": "Friluftsmål",
  "layers.septic": "Septiktömningsstationer",
  "layers.ais": "AIS-objekt",
  "layers.ice": "Isläge",
  "layers.navWarnings": "Sjövarningar",
  "navWarning.number": "Varning {{number}}",
  "navWarning.published": "Publicerad {{time}}",
  "navWarning.dataAttribution": "Data: Traficoms sjövarningar (öppen data)",
  "information.dataSources.traficomNavWarningsText": "Inkluderar sjövarningar (Merivaroitukset) via Traficoms öppna WFS.",
  "forecast.attr.wind": "Vind",
  "forecast.attr.wind_gust": "Vindby",
  "forecast.attr.temperature": "Temperatur",
  "forecast.attr.rainfall": "Nederbörd",
  "forecast.attr.cloud_cover": "Molnighet",
  "forecast.isobars": "Lufttryck",
  "forecast.play": "Spela",
  "forecast.pause": "Paus",
  "forecast.prev": "Föregående timme",
  "forecast.next": "Nästa timme",
  "forecast.loading": "Laddar prognos…",
  "forecast.modelRun": "Modellkörning {{time}}",
  "forecast.source": "Ilmatieteenlaitos Harmonie",
  "forecast.point.title": "Prognos här",
  "forecast.point.close": "Stäng",
  "forecast.point.noData": "Ingen data",
  "forecast.premiumTimeline": "Senare timmar kräver Premium",
  "layers.networkTiles": "Mobilnätskvalitet",
  "layers.networkTilesTech": "Nät",
  "layers.networkTilesTech4g": "4G",
  "layers.networkTilesTech5g": "5G",
  "layers.networkTilesOperator": "Operatör",
  "layers.networkTilesOperatorElisa": "Elisa",
  "layers.networkTilesOperatorDna": "DNA",
  "layers.networkTilesOperatorTelia": "Telia",
  "layers.networkTilesMetric": "Mått",
  "layers.networkTilesMetricDownload": "Nedladdningshastighet",
  "layers.networkTilesMetricUpload": "Uppladdningshastighet",
  "layers.networkTilesMetricLatency": "Latens",
  "layers.networkTilesMetricRsrp": "RSRP-signal",
  "layers.networkTilesLegendTitle": "Teckenförklaring för nätkvalitet",
  "layers.networkTilesLegendLoading": "Laddar nätverkstile",
  "layers.networkTilesBandVeryBad": "Mycket dålig",
  "layers.networkTilesBandBad": "Dålig",
  "layers.networkTilesBandFair": "Måttlig",
  "layers.networkTilesBandGood": "Bra",
  "layers.networkTilesBandExcellent": "Utmärkt",
  "layers.raster2025": "Sjökort (raster)",
  "layers.rasterSpecial": "Specialkartor",
  "layers.avoinMerikartta": "Öppet sjökort (vektor)",
  "layers.maastokartta": "Terrängkarta (Maastokartta)",
  "layers.combined": "Sjö- och terrängkarta (vektor)",
  "layers.s57": "Sjökort (S57, vektor)",
  "layers.scoutRoutes": "Scoutrutter",
  "layers.scoutRouting": "Automatisk ruttning via scoutrutter",
  "layers.savedPlaces": "Sparade platser",
  "layers.restriction01SpeedLimit": "Hastighetsbegränsning",
  "layers.restriction02NoWake": "Förbud mot svallbildning",
  "layers.restriction03NoWindsurfing": "Förbud mot vindsurfing",
  "layers.restriction04NoJetSki": "Körning med vattenskoter förbjuden",
  "layers.restriction05NoMotorPower": "Fartygs färd med motorkraft förbjuden",
  "layers.restriction06NoAnchoring": "Ankarsförbud",
  "layers.comingSoon": "Kommer snart",
  "layers.scoutSubscription": "Scoutprenumeration",
  "layers.premium": "Premium",
  "layers.beta": "Beta",
  "layers.premiumBeta": "Premium beta",
  "s57.infoDialogTitle": "S57-vektorkartor",
  "s57.infoDialogParagraph1": "Tack för att du provar Sailmates nya vektorkarta. Vi vill göra den så bra som möjligt för våra farvatten — din återkoppling hjälper oss framåt.",
  "s57.infoDialogParagraph2": "Kartan bygger på Traficoms officiella S-57-data. Vi har justerat presentationen för finska båtare; berätta gärna hur kartan ser ut och hur innehållet fungerar vid olika zoomnivåer.",
  "s57.infoDialogMobileSpring": "Kommer till mobilapparna under våren.",
  "s57.betaWarning": "S57-kartor är i betatestning",
  "s57.feedbackTitle": "Återkoppling vektorkartor",
  "s57.feedbackSendButton": "Skicka återkoppling",
  "s57.feedbackButton": "Återkoppling",
  "s57.feedbackMailtoHint": "Du kan skicka återkoppling i Gmail i webbläsaren eller i din e-postapp. Om inget öppnas, kopiera adressen och klistra in den i e-post.",
  "s57.feedbackOpenInGmail": "Öppna i Gmail",
  "s57.feedbackOpenInMailApp": "E-postprogram",
  "s57.feedbackCopyEmail": "Kopiera adress",
  "s57.feedbackCopyEmailSuccess": "Adressen kopierades — klistra in den i e-post.",
  "s57.feedbackCopyEmailFailed": "Kunde inte kopiera — markera adressen ovan manuellt.",
  "reachableArea.title": "Nåbart område",
  "reachableArea.distanceNm": "Avståndsbudget",
  "reachableArea.nm": "nm",
  "reachableArea.km": "km",
  "reachableArea.hint": "Visar farleder som kan nås från den sista vägpunkten med lokal farledsruttning.",
  "routePlan.downloadGPX": "Ladda ner planen som GPX",
  "routePlan.groupLegs": "Gruppera valda etapper",
  "routePlan.ungroupLegs": "Avgruppera etapper",
  "routePlan.ungroupLegsAria": "Avgruppera",
  "routePlan.title": "Ruttplan",
  "routePlan.nameLabel": "Ruttnamn",
  "routePlan.namePlaceholder": "Namnlös rutt",
  "routePlan.totalDistance": "Total distans",
  "routePlan.eta": "ETA",
  "routePlan.waypoints": "Vägpunkter",
  "routePlan.waypoint": "Vägpunkt",
  "routePlan.start": "Start",
  "routePlan.finish": "Mål",
  "routePlan.emptyTitle": "Inga vägpunkter ännu",
  "routePlan.emptyHintOff": "Välj ruttningsläge från verktygsfältet för att börja planera.",
  "routePlan.emptyHintOn": "Håll kartan nedtryckt för att lägga till vägpunkter. Tryck på en rad för att ta bort, eller ta bort från kartan.",
  "routePlan.clear": "Rensa",
  "routePlan.clearConfirmTitle": "Rensa rutten?",
  "routePlan.clearConfirmBody": "Du har ändringar som inte har sparats i molnet. Om du rensar försvinner de.",
  "routePlan.calculating": "Beräknar rutt…",
  "routePlan.savedLocally": "Sparat lokalt",
  "routePlan.untitledRoute": "Namnlös rutt",
  "routePlan.editVesselSettings": "Redigera",
  "routePlan.cloudTitle": "Molnsynk",
  "routePlan.cloudSubtitle": "Spara rutten i molnet och använd den på andra enheter.",
  "routePlan.cloudNameLabel": "Ruttnamn",
  "routePlan.cloudNameHelper": "Namnet sparas i molnet när du klickar Spara.",
  "routePlan.cloudSave": "Spara i molnet",
  "routePlan.cloudSaveChanges": "Spara ändringar",
  "routePlan.cloudRenameHint": "Namnbyte kräver Spara",
  "routePlan.cloudNotSaved": "Inte sparad",
  "routePlan.cloudSynced": "Synkad",
  "routePlan.cloudSyncing": "Synkar…",
  "routePlan.cloudSyncError": "Synk misslyckades",
  "routePlan.cloudPending": "Ändringar väntar",
  "routePlan.cloudAutoSync": "Automatisk sparning aktiverad",
  "routePlan.cloudAutoSaveLabel": "Automatisk sparning",
  "routePlan.cloudSaveManually": "Spara manuellt när du är redo.",
  "routePlan.cloudLastSynced": "Senast synkad {{time}}",
  "routePlan.cloudLoginTitle": "Logga in för att spara rutter",
  "routePlan.cloudLoginBody": "Skapa ett konto för att spara rutter i molnet och hålla dem synkade.",
  "routePlan.cloudLoginCta": "Logga in",
  "routePlan.cloudPremiumTitle": "Premium krävs",
  "routePlan.cloudPremiumBody": "Molnsparning är en Premium-funktion.",
  "routePlan.cloudPremiumCta": "Uppgradera",
  "routePlan.cloudCheckingAccount": "Kontrollerar konto…",
  "routePlan.cloudSaveError": "Det gick inte att spara rutten.",
  "routePlan.cloudAuthError": "Saknar sessions-token.",
  "routePlan.cloudProfileMissing": "Profil saknas.",
  "routePlan.cloudNoWaypoints": "Lägg till minst en punkt för att spara.",
  "routePlan.cloudLoginRequired": "Logga in för att spara den här rutten.",
  "routePlan.cloudPremiumRequired": "Premiumprenumeration krävs.",
  "routePlan.routingAutoFailed": "Det gick inte att hitta en rutt.",
  "routePlan.addWaypointFailed": "Det gick inte att lägga till vägpunkt.",
  "routePlan.insertWaypointFailed": "Det gick inte att infoga vägpunkt.",
  "routePlan.removeWaypointFailed": "Det gick inte att ta bort vägpunkt.",
  "routePlan.relocateWaypointFailed": "Det gick inte att flytta vägpunkt.",
  "routePlan.loadRouteFailed": "Det gick inte att ladda rutten.",
  "routePlan.editingEnabled": "Ruttredigering aktiverad",
  "routePlan.waypointLimitTitle": "Logga in för längre rutter",
  "routePlan.waypointLimitMessage": "Du kan lägga till upp till tre vägpunkter utan konto. Logga in för att låsa upp längre ruttplanering och synka dina rutter.",
  "routePlan.waypointLimitHint": "Det tar bara en minut — vi skickar en engångskod till din e-post.",
  "routePlan.waypointLimitCta": "Logga in",
  "routePlan.summary": "Ruttsammanfattning",
  "routePlan.etaLabelShort": "ETA {{eta}}",
  "routePlan.trackedWaypointChip": "Spår",
  "routePlan.waypointModeAuto": "Farled",
  "routePlan.waypointModeManual": "Linje",
  "routePlan.deleteWaypointTitle": "Ta bort vägpunkt?",
  "routePlan.deleteWaypointMessage": "Är du säker på att du vill ta bort \"{{waypoint}}\" (vägpunkt {{index}})? Denna åtgärd kan inte ångras.",
  "routePlan.delete": "Ta bort",
  "routePlan.cancel": "Avbryt",
  "routes.title": "Mina rutter",
  "routes.subtitle": "Hantera och ladda dina sparade rutter.",
  "routes.currentRoute": "Aktuell rutt",
  "routes.selectedRoute": "Vald rutt",
  "routes.saveNew": "Spara som ny",
  "routes.saveNewDialogTitle": "Namn på ny rutt",
  "routes.overwrite": "Skriv över vald",
  "routes.loadToPlanner": "Öppna",
  "routes.delete": "Ta bort",
  "routes.cancel": "Avbryt",
  "routes.refresh": "Uppdatera",
  "routes.loading": "Läser in rutter…",
  "routes.ready": "Redo",
  "routes.calculating": "Beräknar",
  "routes.count": "{{count}} rutter",
  "routes.waypointsCount": "{{count}} punkter",
  "routes.updatedAt": "Uppdaterad {{date}}",
  "routes.searchPlaceholder": "Sök rutter",
  "routes.emptyTitle": "Inga sparade rutter ännu",
  "routes.emptyHint": "Spara din aktuella rutt så visas den här.",
  "routes.selectTitle": "Välj en rutt",
  "routes.selectHint": "Välj en rutt för att se detaljer och åtgärder.",
  "routes.loginRequired": "Logga in för att se dina sparade rutter.",
  "routes.login": "Logga in",
  "routes.sharedHint": "Kod för delad rutt",
  "routes.deleteConfirmTitle": "Ta bort rutt?",
  "routes.deleteConfirmMessage": "Ta bort \"{{name}}\"? Detta kan inte ångras.",
  "routes.errorMissingToken": "Åtkomsttoken saknas.",
  "routes.errorMissingProfile": "Användarprofilens id saknas.",
  "routes.errorMissingSelection": "Välj en rutt först.",
  "routes.errorSubscriptionRequired": "En giltig prenumeration krävs för att spara och hantera rutter.",
  "routes.errorGeneric": "Något gick fel.",
  "routes.untitledRoutePlaceholder": "Namnlös rutt",
  "routes.importExport.exportCurrent": "Exportera aktuell GPX",
  "routes.importExport.exportSelected": "Exportera som GPX",
  "routes.importExport.exportAll": "Exportera alla GPX",
  "routes.importExport.importRoute": "Importera rutt GPX",
  "routes.importExport.exportedSingle": "Rutt exporterad som GPX.",
  "routes.importExport.exportedAll": "{{count}} rutter exporterade som GPX.",
  "routes.importExport.importedRoute": "Rutt importerad till planeraren.",
  "routes.importExport.invalidRouteGpx": "Inga giltiga ruttpunkter hittades i GPX.",
  "routes.importExport.invalidXml": "Ogiltig GPX-fil.",
  "routes.importExport.importFailed": "Import av rutt-GPX misslyckades.",
  "routes.importExport.noSavedRoutes": "Inga sparade rutter att exportera.",
  "routes.importExport.noCurrentRoute": "Den aktuella rutten har inga punkter att exportera.",
  "places.title": "Mina platser",
  "places.subtitle": "Hantera dina sparade platser.",
  "places.selectedPlace": "Vald plats",
  "places.nameLabel": "Namn",
  "places.latitude": "Latitud",
  "places.longitude": "Longitud",
  "places.update": "Spara ändringar",
  "places.delete": "Ta bort",
  "places.cancel": "Avbryt",
  "places.refresh": "Uppdatera",
  "places.loading": "Läser in platser…",
  "places.count": "{{count}} platser",
  "places.updatedAt": "Uppdaterad {{date}}",
  "places.searchPlaceholder": "Sök platser",
  "places.emptyTitle": "Inga sparade platser ännu",
  "places.emptyHint": "Dina sparade platser visas här.",
  "places.selectTitle": "Välj en plats",
  "places.selectHint": "Välj en plats för att se detaljer och åtgärder.",
  "places.loginRequired": "Logga in för att se dina sparade platser.",
  "places.login": "Logga in",
  "places.deleteConfirmTitle": "Ta bort plats?",
  "places.deleteConfirmMessage": "Ta bort \"{{name}}\"? Detta kan inte ångras.",
  "places.errorMissingToken": "Åtkomsttoken saknas.",
  "places.errorMissingProfile": "Användarprofilens id saknas.",
  "places.errorMissingSelection": "Välj en plats först.",
  "places.errorInvalidName": "Ange ett namn.",
  "places.errorInvalidCoordinates": "Ange giltiga koordinater.",
  "places.errorSubscriptionRequired": "En giltig prenumeration krävs för att hantera sparade platser.",
  "places.errorGeneric": "Något gick fel.",
  "places.untitledPlacePlaceholder": "Namnlös plats",
  "places.importExport.exportSelected": "Exportera som GPX",
  "places.importExport.exportAll": "Exportera alla GPX",
  "places.importExport.importPlace": "Importera plats GPX",
  "places.importExport.exportedSingle": "Plats exporterad som GPX.",
  "places.importExport.exportedAll": "{{count}} platser exporterade som GPX.",
  "places.importExport.importedPlace": "Plats importerad.",
  "places.importExport.invalidPlaceGpx": "Ingen giltig waypoint hittades i GPX.",
  "places.importExport.invalidXml": "Ogiltig GPX-fil.",
  "places.importExport.importFailed": "Import av plats-GPX misslyckades.",
  "places.importExport.noSavedPlaces": "Inga sparade platser att exportera.",
  "places.createNewPlace": "Skapa ny plats",
  "places.namePlaceholder": "Ange platsens namn",
  "places.save": "Spara",
  "places.centerOnMap": "Centrera kartan här",
  "places.coordinates": "Koordinater",
  "places.unnamedPlace": "Namnlös plats",
  "places.subscriptionRequiredTitle": "Prenumeration krävs",
  "places.subscriptionRequiredMessage": "Att spara platser kräver en aktiv prenumeration. Prenumerera för att låsa upp denna funktion och hantera dina favoritplatser.",
  "places.subscriptionRequiredHint": "Med en prenumeration kan du spara obegränsat antal platser, få tillgång till avancerade ruttningsfunktioner och mycket mer.",
  "places.viewSubscription": "Visa prenumeration",
  "places.loginRequiredTitle": "Logga in för att spara platser",
  "places.loginRequiredMessage": "Skapa ett konto för att spara platser och hålla dem synkade mellan enheter.",
  "places.loginRequiredHint": "Att skapa ett konto är snabbt och enkelt. Du behöver bara en e-postadress dit vi skickar en verifieringskod.",
  "places.loginRequiredCta": "Logga in",
  "places.categoryLabel": "Kategori",
  "places.descriptionLabel": "Beskrivning",
  "places.descriptionPlaceholder": "Valfri beskrivning",
  "places.filterCategories": "Kategorier",
  "places.filterAllCategories": "Alla kategorier",
  "places.sortDistance": "Avstånd",
  "places.saveAndShowTitle": "Spara och visa ikoner?",
  "places.saveAndShowMessage": "Lagret Mina platser är dolt. Vill du spara platsen och visa ikoner på kartan?",
  "places.saveAndShow": "Spara och visa",
  "places.saveWithoutShowing": "Spara utan att visa",
  "places.categories.FAVORITE": "Favorit",
  "places.categories.FISH": "Fiskeplats",
  "places.categories.COTTAGE": "Stuga",
  "places.categories.WARNING": "Varning",
  "places.categories.INFO": "Info",
  "places.categories.SIGHT": "Sevärdhet",
  "places.categories.ANCHOR": "Ankarplats",
  "places.photos.title": "Foton",
  "places.photos.add": "Lägg till",
  "places.photos.remove": "Ta bort foto",
  "places.photos.onlineOnly": "Foton kan bara hanteras online.",
  "places.photos.maxReached": "Du kan lägga till upp till {{count}} foton.",
  "places.photos.invalidType": "Välj en bildfil.",
  "places.photos.uploadFailed": "Kunde inte ladda upp fotot.",
  "places.photos.deleteFailed": "Kunde inte ta bort fotot.",
  "places.photos.viewFullscreen": "Visa foto i helskärm",
  "places.photos.previous": "Föregående foto",
  "places.photos.next": "Nästa foto",
  "common.cancel": "Avbryt",
  "common.done": "Klar",
  "common.edit": "Redigera",
  "common.sortBy": "Sortera efter",
  "common.sortOrder": "Ordning",
  "common.sortAttributeUpdated": "Uppdaterad",
  "common.sortAttributeCreated": "Skapad",
  "common.sortAttributeName": "Namn",
  "common.sortAsc": "Stigande",
  "common.sortDesc": "Fallande",
  "drawer.openRoutePlan": "Öppna ruttplan",
  "drawer.closeRoutePlan": "Stäng ruttplan",
  "drawer.showRoutePlan": "Visa ruttplan",
  "drawer.hideRoutePlan": "Dölj ruttplan",
  "common.loginRequired": "Inloggning krävs",
  "common.checkingAccount": "Kontrollerar konto…",
  "common.subscriptionRequired": "Prenumeration krävs",
  "common.close": "Stäng",
  "common.notNow": "Inte nu",
  "common.language": "Språk",
  "recreation.titleFallback": "Friluftsmål",
  "recreation.loading": "Laddar…",
  "recreation.loadError": "Kunde inte ladda platsuppgifter.",
  "recreation.description": "Beskrivning",
  "recreation.showMore": "Visa mer",
  "recreation.showLess": "Visa mindre",
  "recreation.highlights": "Höjdpunkter",
  "recreation.arrival": "Hitta hit",
  "recreation.accessibility": "Tillgänglighet",
  "recreation.rules": "Regler",
  "recreation.contacts": "Kontakt",
  "recreation.details": "Uppgifter",
  "recreation.category": "Kategori",
  "recreation.geometry": "Geometri",
  "recreation.owner": "Ägare",
  "recreation.admin": "Förvaltare",
  "recreation.lastModified": "Senast ändrad",
  "recreation.openInLipas": "Öppna i Lipas",
  "recreation.dataAsOf": "Data från {{date}}",
  "recreation.imageCopyright": "© {{copyright}}",
  "recreation.imageAltFallback": "Bild av friluftsmål",
  "recreation.previousImage": "Föregående bild",
  "recreation.nextImage": "Nästa bild",
  "recreation.imageIndex": "{{current}} / {{total}}",
  "harbor.titleFallback": "Hamn",
  "harbor.portNumber": "Hamn",
  "harbor.depth": "Djup",
  "harbor.places": "Platser",
  "harbor.mooring": "Förtöjning",
  "harbor.official": "Officiell",
  "harbor.unofficial": "Inofficiell",
  "harbor.amenitiesTitle": "Service",
  "harbor.openChart": "Öppna hamnkarta",
  "harbor.scoutPort": "Scout-hamn",
  "harbor.spv": "SPV",
  "harbor.overview": "Översikt",
  "harbor.portInfo": "Hamminfo",
  "harbor.servicesTitle": "Service",
  "harbor.relatedContent": "Relaterat innehåll",
  "harbor.relatedArticles": "Relaterade artiklar",
  "harbor.linksTitle": "Länkar",
  "harbor.scoutTip": "Innehåller scoutinformation!",
  "harbor.openContent": "Öppna innehåll",
  "harbor.openArticle": "Öppna artikel",
  "harbor.openScoutChart": "Öppna scoutkarta",
  "harbor.openAerial": "Öppna flygbild",
  "harbor.openSeptit": "Öppna septit.net",
  "harbor.amenities.toilet": "Toalett",
  "harbor.amenities.drinkingWater": "Dricksvatten",
  "harbor.amenities.sauna": "Bastu",
  "harbor.amenities.fuel": "Bränsle",
  "harbor.amenities.restaurant": "Restaurang",
  "harbor.amenities.kiosk": "Kiosk",
  "harbor.amenities.recycling": "Återvinning",
  "harbor.services.wc": "Toalett",
  "harbor.services.shower": "Dusch",
  "harbor.services.drinking_water": "Dricksvatten",
  "harbor.services.electricity": "El",
  "harbor.services.harbour": "Hamn",
  "harbor.services.fuel": "Bränsle",
  "harbor.services.boat_ramp": "Båtramp",
  "harbor.services.septic_tank": "Septiktank",
  "harbor.services.wash_house": "Tvättstuga",
  "harbor.services.engine": "Motorservice",
  "harbor.services.restaurant": "Restaurang",
  "harbor.services.cafe": "Café",
  "harbor.services.kiosk": "Kiosk",
  "harbor.services.foodkiosk": "Matkiosk",
  "harbor.services.sauna": "Bastu",
  "harbor.services.beach": "Badstrand",
  "harbor.services.playground": "Lekplats",
  "harbor.services.grill": "Grill",
  "harbor.services.naturetrail": "Naturstig",
  "harbor.services.sigthseeing": "Sevärdheter",
  "harbor.services.amusement": "Nöjen",
  "harbor.services.shop": "Butik",
  "harbor.services.pharmacy": "Apotek",
  "harbor.services.bank": "Bank",
  "harbor.services.post_office": "Post",
  "harbor.services.alko": "Alko",
  "harbor.services.bus": "Buss",
  "harbor.services.ferry": "Färja",
  "harbor.services.accommodation": "Boende",
  "harbor.services.guidance": "Vägledning",
  "harbor.services.recycling": "Återvinning",
  "harbor.services.otherservice": "Annan service",
  "harbor.services.dentist": "Tandläkare",
  "harbor.services.taxi": "Taxi",
  "harbor.services.doctor": "Läkare",
  "harbor.services.vet": "Veterinär",
  "harbor.services.wlan": "Wi‑Fi",
  "harbor.voting.sectionTitle": "Årets gästhamnsomröstning",
  "harbor.voting.rateHarborCard": "Betygsätt hamnen",
  "harbor.voting.rateHarbor": "Betygsätt gästhamnen",
  "harbor.voting.rateThisHarbor": "Betygsätt denna gästhamn:",
  "harbor.voting.leaveComment": "Lämna en kommentar",
  "harbor.voting.send": "Skicka",
  "harbor.voting.sending": "Skickar…",
  "harbor.voting.ratingSaved": "Betyget sparades!",
  "harbor.voting.rateAlso": "Betygsätt också:",
  "harbor.voting.category.cleanliness": "Renlighet",
  "harbor.voting.category.facilities": "Service",
  "harbor.voting.category.staff": "Personal",
  "harbor.voting.category.dock": "Brygga",
  "harbor.voting.category.waste": "Avfallshantering",
  "harbor.voting.category.childrenAndYouth": "Barn och ungdomar",
  "harbor.voting.footerBlurb": "Finlands Segling och Båtsport rf har anordnat omröstningen sedan 1987. I år belönas favoriter både kustregionen och i sjölandet.",
  "harbor.voting.errorSave": "Betyget kunde inte sparas. Försök igen.",
  "harbor.voting.partnerLogos": "Samarbetspartners",
  "vesselSettings.title": "Fartygsinställningar",
  "vesselSettings.draft": "Djupgående",
  "vesselSettings.height": "Höjd",
  "vesselSettings.speed": "Medelhastighet",
  "vesselSettings.draftHint": "Beaktas i farledsruttningen",
  "vesselSettings.heightHint": "Beaktas i farledsruttningen vid broar",
  "vesselSettings.speedHint": "Används i beräkningen av restid",
  "vesselSettings.presetSail": "Segelbåtförinställning",
  "vesselSettings.presetMotor": "Motorbåtförinställning",
  "weatherStation.defaultName": "Väderstation",
  "weatherStation.updated": "Uppdaterad",
  "weatherStation.retry": "Försök igen",
  "weatherStation.error": "Kunde inte ladda väderstationsdata.",
  "weatherStation.wind": "Vind",
  "weatherStation.gust": "Vindby",
  "weatherStation.windDirection": "Vindriktning",
  "weatherStation.temperature": "Temperatur",
  "weatherStation.history": "Historik",
  "weatherStation.noHistory": "Ingen historikdata tillgänglig för denna period.",
  "weatherStation.windAndGust": "Vind och vindby",
  "weatherStation.dataAttribution": "Data: FMI (Finska meteorologiska institutet)",
  "weatherStation.last24h": "Senaste 24 timmarna",
  "weatherStation.relativeTime.justNow": "just nu",
  "weatherStation.relativeTime.minutesAgo": "{{count}} min sedan",
  "weatherStation.relativeTime.hoursAgo": "{{count}} tim sedan",
  "weatherStation.relativeTime.daysAgo": "{{count}} dagar sedan",
  "weatherStation.units.ms": "m/s",
  "weatherStation.units.celsius": "°C",
  "weatherStation.units.degrees": "°",

  "auth.login.title": "Logga in",
  "auth.login.subtitle": "Vi skickar en engångskod via e-post.",
  "auth.login.noAccount": "Ingen användare ännu?",
  "auth.login.createAccount": "Skapa användare",
  "auth.login.successTitle": "Inloggad",

  "auth.register.title": "Skapa användare",
  "auth.register.subtitle": "Vi verifierar din e-post och skapar din profil.",
  "auth.register.firstName": "Förnamn",
  "auth.register.lastName": "Efternamn",
  "auth.register.haveAccount": "Har du redan en användare?",
  "auth.register.goToLogin": "Logga in",
  "auth.register.successTitle": "Användare skapad",
  "auth.register.loginReady": "Du kan nu logga in med ditt nya konto.",
  "auth.register.privacyConsent": "Jag har läst och förstått <0>dataskyddsbeskrivningen</0>.",
  "auth.register.privacyRequired": "Godkännande av dataskyddsbeskrivningen krävs för registrering.",

  "auth.common.close": "Stäng",
  "auth.common.email": "E-postadress",
  "auth.common.emailHelper": "Vi skickar en 6-siffrig kod till din e-post.",
  "auth.common.sendCode": "Skicka kod",
  "auth.common.sending": "Skickar…",
  "auth.common.successBody": "Du kan stänga detta fönster.",

  "auth.otp.sentTitle": "Kontrollera din e-post",
  "auth.otp.sentBody": "Vi skickade en 6-siffrig verifieringskod till {{email}}.",
  "auth.otp.codeLabel": "Verifieringskod",
  "auth.otp.codeHelper": "Ange den 6-siffriga koden.",
  "auth.otp.verify": "Verifiera",
  "auth.otp.verifying": "Verifierar…",
  "auth.otp.changeEmail": "Ändra e-post",
  "auth.otp.noCode": "Fick du ingen kod?",
  "auth.otp.resend": "Skicka igen",
  "auth.otp.resendIn": "Skicka igen om {{seconds}} s",

  "account.title": "Konto",
  "account.subtitle": "Hantera din profil och dina inställningar.",
  "account.back": "Tillbaka till kartan",
  "account.loading": "Laddar konto…",
  "account.error": "Kunde inte ladda kontoinformation.",
  "account.loginRequired": "Logga in för att se ditt konto.",
  "account.profile.title": "Profil",
  "account.profile.name": "Namn",
  "account.profile.email": "E-post",
  "account.profile.membership": "Medlemskap",
  "account.profile.merikarhutMember": "Sjöbjörnarnas medlem",
  "account.subscription.title": "Prenumerationer",
  "account.subscription.premium": "Sailmate Premium",
  "account.subscription.scout": "Partiolaisten reitit",
  "account.subscription.active": "Aktiv",
  "account.subscription.expired": "Utgången",
  "account.subscription.none": "Ingen prenumeration",
  "account.subscription.activeUntil": "Aktiv till {{date}}",
  "account.subscription.expiredOn": "Utgången {{date}}",
  "account.cookiePreferences": "Cookie-inställningar",
  "account.delete.title": "Radera konto",
  "account.delete.description": "Tar bort ditt konto och dina data permanent. Det går inte att ångra.",
  "account.delete.button": "Radera konto",
  "account.delete.confirmTitle": "Radera ditt konto?",
  "account.delete.confirmBody": "Detta raderar ditt konto och all tillhörande data permanent. Åtgärden går inte att ångra.",
  "account.delete.confirmButton": "Radera permanent",
  "account.delete.inProgress": "Raderar…",
  "account.delete.errorMissingProfile": "Vi kunde inte bekräfta dina kontouppgifter. Uppdatera och försök igen.",
  "account.delete.errorMissingToken": "Vi kunde inte verifiera din session. Logga in igen.",
  "account.delete.errorGeneric": "Det gick inte att radera kontot. Försök igen.",

  "consent.title": "Analyssamtycke",
  "consent.message": "Vi använder analys för att förbättra appen. Du kan godkänna eller avböja.",
  "consent.accept": "Godkänn",
  "consent.decline": "Avböj",
  "consent.preferencesTitle": "Cookie-inställningar",
  "consent.currentlyAccepted": "Analys är för närvarande godkänd.",
  "consent.currentlyDeclined": "Analys är för närvarande avböjd.",

  "menu.subscription": "Prenumeration",

  "subscription.title": "Sailmate-prenumerationer",
  "subscription.subtitle": "Välj den prenumeration som passar dina behov. Premium ger kraftfulla verktyg för navigation och ruttplanering med tydliga sjökort, medan Scouternas rutter erbjuder beprövade genvägar samt mer information om hamnar och destinationer.",
  "subscription.planDetails": "Priset inkluderar moms 25,5 %. Prenumerationen gäller i 12 månader och förnyas automatiskt.",
  "subscription.scoutDescription": "Partiolaisten reitit -sisältöpaketti sisältää tarkat tiedot karttoineen yli 450:stä retki- ja luonnonsatamasta ja yli 2000 mpk merkitsemättömiä veneilyreittejä kartalle piirrettyinä. Satamia ja reittejä on Turunmaan saaristossa, Ahvenanmaalla, Suomenlahdella ja Pohjanlahdella. Sisältö on tehty yhteistyössä Turun Partio-Sissit Ry:n kanssa. Partiolaisten reitit -sisältöpaketin voi ostaa sekä Free- että Premium-tasoilla.",
  "subscription.benefits.title": "Varför Sailmate Premium?",
  "subscription.benefits.subtitle": "Lås upp hela Sailmate-upplevelsen med kraftfulla ruttverktyg och kuraterade scoutleder.",
  "subscription.benefits.routes": "Avancerad ruttplanering längs farleder",
  "subscription.benefits.places": "Spara och hantera dina favoritplatser",
  "subscription.benefits.scoutRoutes": "Tillgång till kuraterade scoutrutter (med Scout-prenumeration)",
  "subscription.actions.manage": "Hantera prenumeration",
  "subscription.actions.loading": "Laddar…",
  "subscription.actions.open": "Öppna",
  "subscription.actions.buy": "Välj Premium",
  "subscription.actions.buyScout": "Välj Scout-rutter",
  "subscription.actions.changePlan": "Ändra eller avsluta i Stripe",
  "subscription.manageOnIos": "Hantera på iPhone/iPad (App Store)",
  "subscription.manageOnAndroid": "Hantera på Android (Google Play)",
  "subscription.manageOnMobileHint": "Den här prenumerationen köptes via en mobilbutik. Hantera den på din mobila enhet.",
  "subscription.promotionalTitle": "Kampanjprenumeration",
  "subscription.promotionalBody": "Den här prenumerationen gavs som en kampanj och kan inte hanteras här.",
  "subscription.manageUnavailable": "Prenumerationshantering är inte tillgänglig för detta köp.",
  "subscription.management.title": "Hantera din prenumeration",
  "subscription.management.subtitle": "Stripe hanterar dina betalningar säkert. Du kan uppdatera faktureringsuppgifter eller avsluta när som helst i Stripes portal.",
  "subscription.disclaimer": "Priser, skatter och prenumerationsvillkor visas på Stripe-kassasidan. Genom att prenumerera godkänner du villkoren som visas där.",
  "subscription.loginPrompt": "Logga in för att se dina befintliga prenumerationer eller starta en ny.",
  "subscription.header.routePlanning": "Ruttplanering",
  "subscription.hero.kicker": "Navigera smidigare med Sailmate",
  "subscription.hero.title": "Välj den Sailmate-prenumeration som passar hur du rör dig på vattnet och planerar dina rutter.",
  "subscription.hero.pointPremium": "Kraftfulla verktyg för navigation och planering",
  "subscription.hero.pointScout": "Hamninformation och scouternas genvägsrutter",
  "subscription.hero.pointSync": "Tydliga raster- och vektorkartor för navigation",
  "subscription.trust.secureTitle": "Säker och trygg betalning",
  "subscription.trust.secureBody": "Betalningen behandlas säkert via Stripe. Dina kortuppgifter lagras inte i Sailmate.",
  "subscription.trust.secureProof": "Powered by Stripe",
  "subscription.trust.annualTitle": "Snabbt att komma igång",
  "subscription.trust.annualBody": "Skapa ditt konto på en minut och fortsätt direkt till kassan.",
  "subscription.trust.supportTitle": "Tydliga prenumerationsvillkor",
  "subscription.trust.supportBody": "Moms, förnyelse och faktureringsvillkor visas innan du betalar.",
  "subscription.actions.continuePremium": "Fortsätt till Premium",
  "subscription.actions.continueScout": "Fortsätt till Scout",
  "subscription.actions.choosePremium": "Välj Premium",
  "subscription.actions.chooseScout": "Välj Scout-rutter",
  "subscription.actions.chooseEstonianCharts": "Välj estniska S57-vektorkartor",
  "subscription.restore.title": "Har du redan köpt med det här kontot?",
  "subscription.restore.body": "Om du har prenumererat tidigare, logga in med samma konto för att se dina nuvarande prenumerationer.",
  "subscription.restore.cta": "Logga in och fortsätt",
  "subscription.auth.kicker": "SMIDIG KÖPPROCESS",
  "subscription.auth.title": "Skapa ett Sailmate-konto eller logga in för att fortsätta köpet.",
  "subscription.auth.subtitle": "Om du har använt Sailmate tidigare, logga in med samma e-postadress.",
  "subscription.auth.modeRegister": "Skapa konto",
  "subscription.auth.modeLogin": "Logga in",
  "subscription.auth.pendingTitle": "Fortsätt till {{plan}}",
  "subscription.auth.pendingBody": "Verifiera ditt Sailmate-konto så fortsätter vi dig till kassan för {{plan}}.",
  "subscription.auth.registerCta": "Skapa konto och fortsätt",
  "subscription.auth.loginCta": "Logga in och fortsätt",
  "subscription.auth.verifyCta": "Verifiera och fortsätt",
  "subscription.auth.emailHelper": "Vi skickar en 6-siffrig kod till din e-post.",
  "subscription.auth.otpSentBody": "Vi skickade en 6-siffrig verifieringskod till {{email}}.",
  "subscription.auth.successTitle": "Kontot är klart. Vi fortsätter till kassan.",
  "subscription.auth.successBody": "Du är inloggad. Den säkra kassan öppnas automatiskt.",
  "subscription.auth.successSignedIn": "Du är nu inloggad.",
  "subscription.signedIn.kicker": "Konto klart",
  "subscription.signedIn.title": "Du är inloggad och redo att prenumerera.",
  "subscription.signedIn.body": "Använd ditt Sailmate-konto för att gå till kassan, hantera Stripe-fakturering eller kontrollera din nuvarande prenumerationsstatus.",
  "subscription.signedIn.readyChip": "Inloggad",
  "subscription.signedIn.email": "Kassan och prenumerationshanteringen använder e-postadressen {{email}}.",
  "subscription.signedIn.switchEmail": "Logga in med en annan e-postadress",
  "subscription.redirecting.title": "Förbereder kassan",
  "subscription.redirecting.body": "Ditt konto är klart. Vi fortsätter dig till den säkra kassan.",
  "subscription.plan.featured": "Bäst för aktiv navigation",
  "subscription.plan.addOn": "Ett bra tillägg för upptäcktsfärder",
  "subscription.plan.featuredShort": "Populär",
  "subscription.checkoutReady": "Kassan använder e-postadressen för ditt Sailmate-konto och öppnas i Stripe.",
  "subscription.errors.checkoutUnavailable": "Vi kunde inte förbereda kassan ännu. Kontrollera dina kontouppgifter och försök igen.",
  "subscription.premiumSubtitle": "För ruttplanering och navigation",
  "subscription.premiumDescription": "Prova gratis i 3 dagar. Med Sailmate Premium kan du planera rutter och få tillgång till sjöväder, hamnkartor, extra kartlager och AIS-observationer. Dessutom ingår navigationsfunktioner som positionsvisning, kurslinje, hastighetsvisning, avståndscirkel, sparning av färdad rutt och offlinekartor.\n\nDebiteringen börjar efter den 3 dagar långa provperioden. Du kan avsluta när som helst under provperioden utan att debiteras.",
  "subscription.premiumFeature1": "Tydliga S57-vektorkartor",
  "subscription.premiumFeature2": "Navigera med mobilappen",
  "subscription.premiumFeature3": "Se hamnarnas angöringskartor",
  "subscription.premiumFeature4": "Synkronisera rutter och favoriter till alla dina enheter",
  "subscription.scoutSubtitle": "Kuraterade rutter och hamninformation för utfärdsbåtliv",
  "subscription.estonianChartsTitle": "Estniska S57-vektorkartor",
  "subscription.estonianChartsSubtitle": "Tillägg för estniska farvatten",
  "subscription.estonianChartsDescription": "Lägger till estniska S57-vektorkartor på kartan.",
  "subscription.estonianChartsPremiumRequired": "Kräver en aktiv Sailmate Premium-prenumeration.",
  "subscription.scoutDescriptionShort": "Innehållspaketet Scouternas rutter ger dig över 450 utflykts- och naturhamnar samt över 2 000 sjömil omärkta båtleder direkt på kartan. Innehållet täcker Åbolands skärgård, Åland, Finska viken och Bottenviken, och har tagits fram i samarbete med Turun Partio-Sissit rf.\n\nPaketet kan köpas för både Free- och Premium-nivån.",
  "subscription.scoutFeature1": "Mer information om över 450 utfärds- och naturhamnar",
  "subscription.scoutFeature2": "Över 2 000 sjömil av rutter",
  "subscription.scoutFeature3": "Kuraterade Scout-rutter och hamnuppgifter för nordiska vatten",
  "subscription.paymentReturn.successTitle": "Betalning genomförd",
  "subscription.paymentReturn.successBody": "Din prenumeration aktiveras. Det kan ta en stund innan den syns.",
  "subscription.paymentReturn.cancelTitle": "Betalning avbröts",
  "subscription.paymentReturn.cancelBody": "Inga ändringar gjordes i din prenumeration. Du kan försöka igen när som helst.",
  "subscription.paymentReturn.unknownTitle": "Betalningsuppdatering",
  "subscription.paymentReturn.unknownBody": "Vi tog emot en betalningsuppdatering. Kontrollera din prenumerationsstatus nedan.",
  "subscription.paymentReturn.errorTitle": "Betalning misslyckades",
  "subscription.paymentReturn.errorBody": "Vi kunde inte slutföra betalningen. Försök igen eller använd ett annat kort. Om problemet kvarstår, kontakta support.",
  "subscription.errors.misconfigured": "Stripe-konfigurationen saknas. Kontakta support.",
  "subscription.errors.portalUnavailable": "Hantering av prenumerationer är inte tillgänglig just nu.",

  "auth.errors.invalidForm": "Kontrollera fälten och försök igen.",
  "auth.errors.invalidCode": "Ange en giltig 6-siffrig kod.",
  "auth.errors.emailInUse": "Den här e-postadressen används redan. Försök logga in istället.",
  "auth.errors.loginFailed": "Inloggningen misslyckades. Kontrollera adressen och försök igen. Om du inte har ett konto kan du skapa ett genom att välja \"Skapa användare\".",
  "auth.errors.otpFailed": "Kodverifieringen misslyckades. Försök igen.",
  "auth.errors.generic": "Något gick fel. Försök igen.",
  "errorBoundary.title": "Något gick fel",
  "errorBoundary.subtitle": "Oväntat fel",
  "errorBoundary.message": "Ett oväntat fel uppstod i applikationen. Du kan försöka igen, ladda om sidan eller återvända till startsidan.",
  "errorBoundary.retry": "Försök igen",
  "errorBoundary.reload": "Ladda om sidan",
  "errorBoundary.goHome": "Till startsidan",
  "errorBoundary.details": "Felinformation",
  "errorBoundary.copyError": "Kopiera fel",
  "errorBoundary.errorMessage": "Felmeddelande",
  "errorBoundary.componentStack": "Komponentstack",
  "errorBoundary.helpText": "Om problemet kvarstår, kontakta support.",
  "webglError.title": "WebGL är inte tillgängligt",
  "webglError.subtitle": "Grafisk acceleration krävs",
  "webglError.message": "Denna applikation kräver WebGL för att visa kartor och grafik. WebGL verkar vara inaktiverat eller inte tillgängligt i din webbläsare.",
  "webglError.howToEnable": "Så här aktiverar du WebGL:",
  "webglError.step1": "Uppdatera din webbläsare till den senaste versionen",
  "webglError.step2": "Kontrollera dina webbläsarinställningar och aktivera hårdvaruacceleration",
  "webglError.step3": "Om du använder Chrome/Edge: Gå till chrome://settings/system och aktivera 'Använd hårdvaruacceleration när tillgängligt'",
  "webglError.reload": "Ladda om sidan",
  "webglError.helpText": "Efter att ha aktiverat WebGL, ladda om sidan för att fortsätta.",

  "onboarding.title": "Snabbstart",
  "onboarding.stepCount": "Steg {{current}} av {{total}}",
  "onboarding.progressLabel": "Konfigurationsframsteg",
  "onboarding.selected": "Vald",
  "onboarding.dontShowAgain": "Visa inte detta igen",
  "onboarding.back": "Tillbaka",
  "onboarding.finish": "Börja segla",
  "onboarding.next": "Nästa",
  "onboarding.step1.kicker": "Välkommen",
  "onboarding.step1.title": "Välkommen till nya Sailmate",
  "onboarding.step1.body": "Sailmates nya webbapp erbjuder ännu mer omfattande verktyg för att planera lyckade båtturer. Du kan mycket väl hitta brister eller fel i den nya appen — berätta om dem för oss!",
  "onboarding.step1.pill1Title": "Smidig ruttplanering",
  "onboarding.step1.pill1Body": "Skapa ruttplaner i den nya lättanvända webbappen och navigera med Sailmate-mobilappen med en Premiumprenumeration.",
  "onboarding.step1.pill2Title": "En vy för båtliv",
  "onboarding.step1.pill2Body": "I Sailmate web utforskar du sjökort, hamnar, väder och AIS-trafik i en och samma vy.",
  "onboarding.step2.kicker": "Sjökort",
  "onboarding.step2.title": "Välj kartstil",
  "onboarding.step2.body": "Välj ett startlager. Du kan byta när som helst i Kartlager-menyn.",
  "onboarding.step2.rasterTitle": "Raster sjökort",
  "onboarding.step2.rasterBody": "Officiella papperssjökort i digital form.",
  "onboarding.step2.rasterFeature1": "Officiellt sjökort",
  "onboarding.step2.rasterFeature2": "Känd presentation från kartserier",
  "onboarding.step2.rasterFeature3": "Viktig information alltid synlig",
  "onboarding.step2.vectorTitle": "Vektor sjökort",
  "onboarding.step2.vectorBody": "Ren vektorstil som förblir skarp när du zoomar.",
  "onboarding.step2.vectorFeature1": "Innehållet anpassas när du zoomar in och ut",
  "onboarding.step2.vectorFeature2": "Tydligare presentation",
  "onboarding.step2.vectorFeature3": "För närvarande baserad på öppna data; officiella vektorsjökort kommer snart!",
  "onboarding.step2.footer": "Tips: öppna Kartlager när som helst för att växla mellan raster och vektor.",
  "onboarding.step3.kicker": "Prenumerationer",
  "onboarding.step3.title": "Kom längre med Premium och scoutrutter",
  "onboarding.step3.body": "Förbättra din båtlivsupplevelse med ett Premium-abonnemang och innehållspaketet Scouternas rutter.",
  "onboarding.step3.premiumTitle": "Premium",
  "onboarding.step3.premiumChip": "För navigering",
  "onboarding.step3.premiumBody": "Med Premium blir ruttplanerna verklighet.",
  "onboarding.step3.premiumFeature1": "Navigera med mobilappen",
  "onboarding.step3.premiumFeature2": "Inseglingskartor för hamnar",
  "onboarding.step3.premiumFeature3": "",
  "onboarding.step3.scoutTitle": "Scoutrutter",
  "onboarding.step3.scoutChip": "Lokalkännedom",
  "onboarding.step3.scoutBody": "Scoutrutter och hamninformation.",
  "onboarding.step3.scoutFeature1": "Omfattande detaljer om 450+ utflykts- och naturhamnar",
  "onboarding.step3.scoutFeature2": "2 000 nautiska mil med omarkerade rutter",
  "onboarding.step3.scoutFeature3": "",
  "onboarding.step3.viewPlans": "Visa abonnemang",
  "onboarding.step3.login": "Logga in",
  "onboarding.step3.loggedInHint": "Du är inloggad. Hantera din prenumeration när som helst från kontomenyn.",
  "onboarding.close": "Stäng",
  "onboarding.footerTour": "Utforska snabbturen",
  "tour.stepCount": "Steg {{current}} av {{total}}",
  "tour.back": "Tillbaka",
  "tour.next": "Nästa",
  "tour.done": "Klar",
  "tour.steps.menu.title": "Huvudmeny",
  "tour.steps.menu.body": "Konto, rutter, inställningar och support samlade på ett ställe.",
  "tour.steps.routeDrawer.title": "Ruttpanelen",
  "tour.steps.routeDrawer.body": "Se ruttplanens vägpunktar och spara rutten i molnet.",
  "tour.steps.routing.title": "Ruttplaneringens läge",
  "tour.steps.routing.body": "Välj läge för att lägga till sparad plats, automatisk farledsruttning eller manuell ruttning. Lägg till en plats eller vägpunkt genom att långtrycka på kartan.",
  "tour.steps.reach.title": "Nåbart område",
  "tour.steps.reach.body": "Se hur långt du kan nå längs farleder från den senaste vägpunktens läge, baserat på avståndet du anger.",
  "tour.steps.search.title": "Sök",
  "tour.steps.search.body": "Hoppa till platser och hamnar med snabb sökning.",
  "tour.steps.savedPlace.title": "Lägg till en sparad plats",
  "tour.steps.savedPlace.body": "När ruttredigering inte är aktiv kan du lägga till en sparad plats genom att långtrycka på kartan.",
  "tour.steps.editRoute.title": "Redigera rutten",
  "tour.steps.editRoute.body": "I ruttredigeringsläget lägger du till en ruttpunkt genom att långtrycka på kartan. Du kan lägga till en ruttpunkt mitt i en leg genom att dra rutten till en ny position. På pekskärmar, långtryck på ruttlinjen eller en ruttpunkt för att börja flytta den.",
  "tour.steps.layers.title": "Kartlager",
  "tour.steps.layers.body": "Välj kartstil och slå på väder, AIS och överlägg.",
  "tour.steps.controls.title": "Kartkontroller",
  "tour.steps.controls.body": "Zooma och återställ norr med en hand.",
  "tour.steps.forecast.title": "Väderprognos",
  "tour.steps.forecast.body": "Öppna väderprognosen på kartan och bläddra vind, byar, temperatur och mer över tid. Tryck på kartan för en punktprognos."
}
